import { AuxFrameTitle } from './AuxFrameTitle';
export default AuxFrameTitle;
